<template> 
                <Table :priv="priv" @open-dialog="OpenDialog" @get-data="GetLists" :data="data"></Table>
     
</template>
<script>
import Table from "./Components/Tables/Table.vue"; 


export default {
    components: {
        Table 
    },
    props: {
        priv: Object
    },
    data() {
        return {
            loading: null,
            data: [
                {
                    id: 1,
                    exceptName: "İntihar (adətən müqavilənin ilk 12–24 ayı ərzində)",
                    created: "01.07.2025 14:32",
                    updated: "05.07.2025 10:15"
                },
                {
                    id: 2,
                    exceptName: "Müharibə, hərbi əməliyyatlar, terror aktları",
                    created: "02.07.2025 09:05",
                    updated: "06.07.2025 12:40"
                },
                {
                    id: 3,
                    exceptName: "Cinayət törədərkən ölüm",
                    created: "03.07.2025 17:22",
                    updated: "07.07.2025 08:55"
                },
                {
                    id: 4,
                    exceptName: "Alkoqol/narkotik sərxoşluğu",
                    created: "03.07.2025 17:22",
                    updated: "07.07.2025 08:55"
                }
            ],
            loading2: null,
            data2: [],
            list: {
                dialogVis: false,
                object: null
            },
        }
    },
    methods: {
        GetLists() {

            //None
        },
        GetLists2() {
            this.loading2 = true
            //None
        },
        Insert() {
            if (this.type == 'LIST') {
                this.list.dialogVis = false
                this.GetLists()
            }
        },
        OpenDialog(index, edit, object, type) {
            this.type = type
            this.list.constindex = index
            if (type == 'LIST') {
                this.list.constindex = index
                this.list.dialogVis = true
                this.list.object = object
            }
            this.editing = edit
        }
    },
    mounted() {
        this.GetLists()
        this.GetLists2()
    }
}
</script>